import React from "react";
import {
  Nav,
  Form,
  FormControl,
  Badge,
  Offcanvas,
  Navbar,
  Image,
} from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { TiThLargeOutline } from "react-icons/ti";
import { IoMdBook, IoIosNotificationsOutline } from "react-icons/io";
import { BsBuildings } from "react-icons/bs";
import { FaGlasses, FaRegUserCircle, FaRegCheckSquare } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";
import { LuCopyCheck } from "react-icons/lu";
import { RiPieChartLine } from "react-icons/ri";
import { FiLifeBuoy } from "react-icons/fi";
import "../../pages/student/profiles/profile.css";
import { URLS } from "../../utils/URL";
import { useQuery } from "react-query";
import api from "../../utils/helper";

const SideBar = ({ show, onClose }) => {
  const location = useLocation();

  const userProfileImg =
    localStorage.getItem("profile_img") || "/images/default-avatar.png";

  const { data, isLoading, error } = useQuery(
    ["courses", "vendors/courses"],
    () => api.get("vendors/courses")
  );

  // Custom NavLink component that works with react-router
  const CustomNavLink = ({ to, children, className }) => {
    const isActive = location.pathname === to;
    // const isActive =
    //   location.pathname === to || location.pathname.startsWith(to);

    return (
      <Nav.Item className="mb-2">
        <Link
          to={to}
          className={`nav-link ${className} ${
            isActive
              ? "text-dark textCourse active"
              : "text-primary textOverview"
          }`}
        >
          {children}
        </Link>
      </Nav.Item>
    );
  };

  const sidebarContent = (
    <>
      {/* Mobile Search and Notifications */}
      {/* <div className="d-block d-lg-none px-3 mb-4 d-flex">
        <Form className="d-flex mb-3">
          <div className="position-relative w-100">
            <FormControl
              type="search"
              placeholder="Search"
              className="text-white searchBox"
              aria-label="Search"
            />
            <Search className="position-absolute start-0 top-50 translate-middle-y mx-3 searchIcon" />
          </div>
        </Form>

        <div className="d-flex align-items-center">
          <div className="position-relative">
            <IoIosNotificationsOutline color="#396091" size={28} />
            <Badge
              bg="light"
              className="bgNav position-absolute top-0 start-100 translate-middle rounded-pill text-black border"
            >
              10
            </Badge>
          </div>
        </div>
      </div> */}

      <Nav className="flex-column justify-content-between mt-5 ">
        <div>
          <div className="bajaj-box">
            <Image
              //src="/images/bajaj-blue.png"
              src={
                userProfileImg
                  ? URLS.IMG_URL + userProfileImg
                  : "/images/Avatar.png"
              }
              style={{
                height: "35px",
                width: "140px",
              }}
            />
          </div>
          <CustomNavLink
            to="/vendor/"
            className={` ${
              location.pathname === "/vendor/"
                ? "text-primary textOverview active"
                : "text-dark "
            } textCourse`}
          >
            <TiThLargeOutline
              className="me-2"
              color={
                location.pathname === "/vendor/" ? "#136ABE" : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Overview</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/approvals"
            className={` ${
              location.pathname.startsWith("/vendor/approvals") ||
              location.pathname === "/vendor/approval-list"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <div className="d-flex justify-content-between">
              <div>
                <LuCopyCheck
                  className="me-2"
                  color={
                    location.pathname.startsWith("/vendor/approvals")
                      ? "#136ABE"
                      : "rgba(0,0,0,0.7)"
                  }
                  size={20}
                />

                <span>Approvals</span>
              </div>
              <span
                style={{
                  background: "#ea9d66",
                  marginTop: "4px",
                  marginRight: "17px",
                }}
                className="px-2 ms-4 rounded-pill text-light badge align-items-center mb-0"
              >
                {data?.data?.data?.filter((c) => c.status == "pending")?.length}{" "}
                {/* 3 */}
              </span>
            </div>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/courses"
            className={` ${
              location.pathname.startsWith("/vendor/courses") ||
              location.pathname === "/vendor/add-course" ||
              location.pathname === "/vendor/add-leason" ||
              location.pathname === "/vendor/add-module" ||
              location.pathname === "/vendor/add-prerecord" ||
              location.pathname === "/vendor/add-prerecord-lesson" ||
              location.pathname === "/vendor/live-session" ||
              location.pathname === "/vendor/upcoming-session"
                ? "text-primary textOverview active"
                : "text-dark "
            } textCourse`}
          >
            <IoMdBook
              className="me-2"
              color={
                location.pathname.startsWith("/vendor/courses")
                  ? "#136ABE"
                  : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Courses</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/college-list"
            className={` ${
              location.pathname.startsWith("/vendor/college-list") ||
              location.pathname === "/vendor/add-college"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <BsBuildings
              className="me-2"
              color={
                location.pathname.startsWith("/vendor/college-list")
                  ? "#136ABE"
                  : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Colleges</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/teacher-list"
            className={` ${
              location.pathname.startsWith("/vendor/teacher-list") ||
              location.pathname === "/vendor/add-teacher"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <FaGlasses
              className="me-2"
              color={
                location.pathname.startsWith("/vendor/teacher-list")
                  ? "#136ABE"
                  : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Teachers</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/student-list"
            className={` ${
              location.pathname.startsWith("/vendor/student-list") ||
              location.pathname === "/vendor/add-student"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <FaRegUserCircle
              className="me-2"
              color={
                location.pathname.startsWith("/vendor/student-list")
                  ? "#136ABE"
                  : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Students</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/college"
            className={` ${
              location.pathname.startsWith("/vendor/college") ||
              location.pathname === "/vendor/teachers-list" ||
              location.pathname === "/vendor/view-quizzes" ||
              location.pathname === "/vendor/create-details" ||
              location.pathname === "/vendor/show-question" ||
              location.pathname === "/vendor/evaluate-details"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <FaRegCheckSquare
              className="me-2"
              color={
                location.pathname.startsWith("/vendor/college")
                  ? "#136ABE"
                  : "rgba(0,0,0,0.7)"
              }
              size={20}
            />
            <span>Quizzes</span>
          </CustomNavLink>

          <CustomNavLink
            to="/vendor/analytics"
            className={` ${
              location.pathname === "/vendor/analytics"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <RiPieChartLine className="me-2" color="#000000" size={20} />
            <span>Analytics</span>
          </CustomNavLink>

          <div className="approval-box">
            <h5 className="request">Approval Request</h5>
            <p className="contentRequest">
              You have{" "}
              {data?.data?.data?.filter((c) => c.status == "pending")?.length}{" "}
              content approval requests.
            </p>
            <Link
              className="viewrequest"
              to="/vendor/approvals"
              style={{ cursor: "pointer" }}
            >
              View Requests
            </Link>
          </div>
          <CustomNavLink
            to="#"
            className={` ${
              location.pathname === "#"
                ? "text-primary textOverview active"
                : "text-dark"
            } textCourse`}
          >
            <FiLifeBuoy className="me-2" color="#000000" size={20} />
            <span>Need Support?</span>
          </CustomNavLink>
        </div>
      </Nav>
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="d-none d-lg-block sidebar sidebar-bg sideMenu scrollingIcon">
        {sidebarContent}
      </div>

      {/* Mobile Sidebar */}
      <Offcanvas
        show={show}
        onHide={onClose}
        responsive="sm"
        className="sidebar-mobile"
      >
        <Offcanvas.Header closeButton className="bgNav">
          <Offcanvas.Title>
            <Navbar.Brand href="#home">
              <img
                src="/images/Group 1.png"
                height="40"
                className="d-inline-block align-top"
                alt="HyTech Didactic Logo"
              />
            </Navbar.Brand>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{sidebarContent}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SideBar;
